






























import {
  defineComponent, PropType,
} from '@nuxtjs/composition-api';

import { SimpleImage } from '~/components/common/SimpleImage';
import ProductPrice from '~/components/Price.vue';
import { getProductPath } from '~/helpers/productHelpers';
import { ProductInterface } from '~/modules/GraphQL/types';

export default defineComponent({
  name: 'ProductsInRange',
  components: {
    SimpleImage,
    ProductPrice,
  },
  props: {
    products: {
      type: Array as PropType<ProductInterface[]>,
      required: true,
    },
  },
  setup() {
    const sanitiseName = (name: string) => name.replace(/ *\([^)]*\) */g, '').replace(' -', '');

    return {
      sanitiseName,
      getProductPath,
    };
  },
});
